import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

export type SurveyConfiguration =
  core.common.Identified<SurveyConfiguration.Id> &
    core.common.Named &
    core.common.Coded & {
      tools: SurveyConfiguration.Tools
      /**
       * Absent when the functional usage attributes are not deployed (e.g.
       * Space Lite).
       */
      functionalUsage?: SurveyConfiguration.FunctionalUsage
    }

export namespace SurveyConfiguration {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export interface FunctionalUsage {
    requireFunctionalUsageAssignmentsForSelectedAccounts: boolean
    requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages: boolean
  }
  export namespace FunctionalUsage {
    export const DEFAULT: FunctionalUsage = {
      requireFunctionalUsageAssignmentsForSelectedAccounts: false,
      requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages: false,
    }
  }

  export interface Tools {
    allowUsersToUnlockRoomsDirectly: boolean
  }
  export namespace Tools {
    export const DEFAULT: Tools = {
      allowUsersToUnlockRoomsDirectly: false,
    }
  }

  export type Input = core.common.Identified.Optionally<Id> & {
    tools: SurveyConfiguration.Tools
    functionalUsage?: SurveyConfiguration.FunctionalUsage
  }
  export namespace Input {
    export const isInput: TypeChecker<Input> = TypeChecker.Factory.intersection(
      TypeChecker.Factory.optional(core.dms.data.Record.Id.isId),
      TypeChecker.Factory.object({
        functionalUsage: TypeChecker.Factory.optional(
          TypeChecker.Factory.object<SurveyConfiguration.FunctionalUsage>({
            requireFunctionalUsageAssignmentsForSelectedAccounts:
              TypeChecker.isBoolean,
            requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages:
              TypeChecker.isBoolean,
          }),
        ),
        tools: TypeChecker.Factory.object<SurveyConfiguration.Tools>({
          allowUsersToUnlockRoomsDirectly: TypeChecker.isBoolean,
        }),
      }),
    )
    export const assertIsInput: TypeAsserter<Input> =
      TypeAsserter.Factory.from(isInput)

    export const DEFAULT: Input = {
      tools: Tools.DEFAULT,
    }
  }
}
